import { useMemo } from "react";
import type { AgentUsageMonth } from "@common/schemas/domains/agentRuns/agent-usage.schema";
import { DensityChart } from "@design-system/DensityChart/DensityChart";
import type { DensityChartWindow } from "@design-system/DensityChart/DensityChart.lib";
import timelineStyles from "@components/activityTimeline/ActivityTimelineChart.module.scss";
import {
    formatUsagePeriod,
    toUsageChartDays,
    USAGE_SERIES,
} from "../agentUsageTimeline.lib";

interface AgentUsageTimelineProps {
    months: readonly AgentUsageMonth[];
    isLoading: boolean;
    historyStart: string;
    today: string;
    window: DensityChartWindow;
    onWindowChange: (window: DensityChartWindow) => void;
    onWindowPreview: (window: DensityChartWindow | null) => void;
}

/** The monthly free and paid tokens as bars, with the picked range as the window. */
export function AgentUsageTimeline({
    months,
    isLoading,
    historyStart,
    today,
    window,
    onWindowChange,
    onWindowPreview,
}: AgentUsageTimelineProps) {
    const days = useMemo(() => toUsageChartDays(months), [months]);
    return (
        <section
            className={timelineStyles.timeline}
            aria-label="Usage timeline"
        >
            <DensityChart
                ariaLabel="Tokens used over time"
                startDate={historyStart}
                endDate={today}
                window={window}
                bucketUnit="month"
                days={days}
                series={USAGE_SERIES}
                onWindowChange={onWindowChange}
                onWindowPreview={onWindowPreview}
                formatPeriod={formatUsagePeriod}
                isLoading={isLoading}
            />
        </section>
    );
}
